import { SimpleEmailMessage } from "@redotech/redo-merchant-app-common/simple-email-message";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { UserImage, UserImageSize } from "@redotech/redo-web/user-image";
import type { Value } from "platejs";
import { createSlateEditor } from "platejs";
import { serializeHtml } from "platejs/static";
import { memo, useEffect, useState } from "react";
import type { DraftCollectionItem } from "../db/collections";
import { emailBasePlugins } from "./message-editor/editor-plugins";

export const SendingDraftCard = memo(function SendingDraftCard({
  draft,
  isLast,
}: {
  draft: DraftCollectionItem;
  isLast?: boolean;
}) {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    try {
      const value = JSON.parse(draft.content) as Value;
      const staticEditor = createSlateEditor({
        plugins: emailBasePlugins,
        value,
      });
      void serializeHtml(staticEditor, {
        stripClassNames: true,
        stripDataAttributes: true,
      }).then(setHtml);
    } catch {
      setHtml(null);
    }
  }, [draft.content]);

  return (
    <Flex
      bgColor="primary"
      borderBottomWidth="1px"
      borderColor="primary"
      borderLeftWidth="1px"
      borderRightWidth="1px"
      borderStyle="solid"
      bottomLeftRadius={isLast ? "sm" : undefined}
      bottomRightRadius={isLast ? "sm" : undefined}
      dir="column"
      gap="none"
      overflow="hidden"
    >
      <Flex
        align="center"
        bgColor="primary"
        gap="md"
        justify="space-between"
        p="xl"
      >
        <Flex
          align="flex-start"
          gap="md"
          grow={1}
          minW="none"
          overflow="hidden"
        >
          <UserImage
            alt="You avatar"
            imageUrl={null}
            name="You"
            size={UserImageSize.SMALL}
          />
          <Text fontSize="sm" fontWeight="semibold" textColor="primary">
            You
          </Text>
        </Flex>
        <Text
          fontSize="xs"
          style={{ flexShrink: 0 }}
          textColor="tertiary"
          whiteSpace="nowrap"
        >
          Sending...
        </Text>
      </Flex>
      <Flex bgColor="primary" dir="column" gap="md" p="lg">
        <Flex dir="column" ml="4xl">
          <SimpleEmailMessage
            messageContent={
              html != null
                ? { type: "messageHtml", messageHtml: html }
                : { type: "messageText", messageText: "" }
            }
          />
        </Flex>
      </Flex>
    </Flex>
  );
});
